<template>
  <layout-audioguide>
      <router-link slot="title" to="/">
        <img src="@/assets/titles/et.svg" />
      </router-link>
      <audioguide slot="audioguide" :guides="guides" />
  </layout-audioguide>
</template>

<script>
import LayoutAudioguide from '@/layouts/Audioguide.vue';
import Audioguide from '@/components/Audioguide.vue';

export default {

  name: 'ViewEt',

  components: {
    LayoutAudioguide,
    Audioguide,
  },

  data() {
    return {
      guides: [
        {
          title: 'Sissejuhatus',
          file: 'guides/et/1.mp3',
          icon: 'btns/1.svg',
        }, {
          title: 'Tali Keren',
          file: 'guides/et/2.mp3',
          icon: 'btns/2.svg',
        }, {
          title: 'Ola Hassanain',
          file: 'guides/et/3.mp3',
          icon: 'btns/3.svg',
        }, {
          title: 'Alexandr Morozov',
          file: 'guides/et/4.mp3',
          icon: 'btns/4.svg',
        }, {
          title: 'Tselyuva Appen',
          file: 'guides/et/5.mp3',
          icon: 'btns/5.svg',
        }, {
          title: 'Anna Kaarma',
          file: 'guides/et/6.mp3',
          icon: 'btns/6-et.svg',
        }, {
          title: 'Tanja Engelberts',
          file: 'guides/et/7.mp3',
          icon: 'btns/7.svg',
        }, {
          title: 'Natalia Romik',
          file: 'guides/et/8.mp3',
          icon: 'btns/8.svg',
        }, {
          title: 'Gareth Kennedy',
          file: 'guides/et/9.mp3',
          icon: 'btns/9.svg',
        }, {
          title: 'Laur aKuusk',
          file: 'guides/et/10.mp3',
          icon: 'btns/10.svg',
        }, {
          title: 'Roven Jõekäär',
          file: 'guides/et/11.mp3',
          icon: 'btns/11.svg',
        }, {
          title: 'Madlen Hirtentreu',
          file: 'guides/et/12.mp3',
          icon: 'btns/12-et.svg',
        }, {
          title: 'Terike Haapoja',
          file: 'guides/et/13.mp3',
          icon: 'btns/13-et.svg',
        }, {
          title: 'Jasmina Cibic',
          file: 'guides/et/14.mp3',
          icon: 'btns/14-et.svg',
        },
      ],
    };
  },

};
</script>
